<template>
    <div class="chosedialog">
        <el-dialog :close-on-click-modal="false" v-bind="$attrs" v-on="$listeners" custom-class="body_dilog xuanzewuliao" width="70%" append-to-body>
            <div class="h-rowIn" >
                <div class="h-rowBox">
                    <div class="h-rowCon yxline">

                        <el-table
                                max-height="500px"
                                size="mini"
                                ref="multipleTable"
                                :data="form"
                                :border="true"
                                tooltip-effect="dark"
                                style="width: 100%">

                            <el-table-column
                                    prop="orderDate"
                                    label="订单日期"
                                    width="110"
                                    :formatter="formatDate"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="code"
                                    label="订单号"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="sapCode"
                                    label="sap订单号"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>

                            <el-table-column
                                    prop="purchaseOrderCode"
                                    label="采购组织"
                                    width="80"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="orderNumber"
                                    label="订单数量"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="shuilv"
                                    label="税率"
                                    width="80">
                            </el-table-column>
                            <el-table-column
                                    prop="currency"
                                    label="币种"
                                    width="80"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="unitPrice"
                                    label="单价"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="taxFreeAmount"
                                    label="订单不含税金额"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="totalPrice"
                                    label="订单金额"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="supplierCode"
                                    label="供应商编号"
                                    width="110"
                                    :show-overflow-tooltip="true">
                            </el-table-column>
                            <el-table-column
                                    prop="companyCode"
                                    label="公司主体"
                                    width="220"
                                    :show-overflow-tooltip="true">
                                <template slot-scope="scope">
                                    <dictname category="kkber_value"  :v="scope.row.companyCode"/>
                                </template>
                            </el-table-column>

                        </el-table>
                    </div>

                </div>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import ss from '../../api/SystemService'
    import uploadFile from "../../api/process/account_complainUploadService";
    export default {
        name: "alluser",
        data(){
            return {
                id:null,
                form:[],
                fileList:[],
            }
        },
        methods: {
            handleFilter(){
               ss.invoiceApplyList.selectDetialById(this.id).then(rd=> {
                   if(rd.f){
                       this.form=rd.msg;
/*                       var totalMoney = 0;
                       for(var i=0;i<this.form.list.length;i++){
                         totalMoney+=this.form.list[i].amount;
                       }
                     this.form.totalMoney=totalMoney;*/

                   }else{
                       this.$message.error(rd.msg);
                   }
               });
            },



            //方法区
            formatDate(row, column) {
                // 获取单元格数据
                let date = row[column.property];
                if (date) {
                    return this.transformDate(date)
                } else {
                    return ''
                }
            },
            //标准时间格式转yyyy-MM-dd
            transformDate(date) {
                if (date) {
                    let dt = new Date(date);
                    return dt.getFullYear() + '-' +
                        ((dt.getMonth() + 1) < 10 ? ('0' + (dt.getMonth() + 1)) : (dt.getMonth() + 1)) + '-' +
                        (dt.getDate() < 10 ? ('0' + dt.getDate()) : dt.getDate());
                } else {
                    return ''
                }
            },



        },
        created(){
            this.id=this.invoiceId;
            this.handleFilter();
        },


        props: {
            dialogVisible: {
                type: Boolean,
            },
            invoiceId: {
                type: String,
            },

        }
    }
</script>

<style>
    .xuanzewuliao .el-dialog__header{
        padding-top: 20px;
        padding-left: 20px;
    }
    .xuanzewuliao .el-dialog__body{
        padding: 20px;
    }
    .xuanzewuliao .el-table tbody td .cell {
        padding: 0.1rem 0.1rem !important;
    }
    .xuanzewuliao .h-formbLine .el-form-item__label{
        width: 39%;
    }
    .xuanzewuliao  .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline .h-formbLine .el-form-item__content{
        width: 61%;
    }
    .xuanzewuliao .yxline{
        padding-top: 0;
    }
    .xuanzewuliao .h-pagination{
        padding-top: 0rem;
        padding-bottom: 0rem;
    }
    .xuanzewuliao .h-rowCon{
        padding-bottom: 0rem;
    }
    .w-tongyi {
        padding: 0.1rem 0.25rem;
    }
    .tan.h-formBorder .h-elformWrap-2{
        width: 50%;
    }
    .tan.h-formBorder .h-elformWrap-2 .el-form-item__label{
        width: 22%;
    }
    .tan.h-formBorder .h-elformWrap-2 .el-form-item__content{
        width: 78%;
    }
    /deep/.el-upload-list__item.is-success.focusing .el-icon-close-tip{
        　　display: none !important;
    }
</style>
